import { render, staticRenderFns } from "./OwnerManagement.vue?vue&type=template&id=314eadab&scoped=true"
import script from "./OwnerManagement.vue?vue&type=script&lang=js"
export * from "./OwnerManagement.vue?vue&type=script&lang=js"
import style0 from "./OwnerManagement.vue?vue&type=style&index=0&id=314eadab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314eadab",
  null
  
)

export default component.exports